import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const FacebookIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3456_16035)">
        <path
          d="M12 24.0001C18.6274 24.0001 24 18.6275 24 12.0001C24 5.37264 18.6274 6.10352e-05 12 6.10352e-05C5.37258 6.10352e-05 0 5.37264 0 12.0001C0 18.6275 5.37258 24.0001 12 24.0001Z"
          fill="#3C5A9A"
        />
        <path
          d="M15.9024 3.68335H13.2441C11.6665 3.68335 9.91189 4.34683 9.91189 6.63352C9.91959 7.43028 9.91189 8.19335 9.91189 9.05214H8.08691V11.9562H9.96837V20.3166H13.4256V11.901H15.7075L15.914 9.04399H13.3661C13.3661 9.04399 13.3718 7.77305 13.3661 7.40396C13.3661 6.50031 14.3063 6.55206 14.3629 6.55206C14.8103 6.55206 15.6803 6.55337 15.9037 6.55206V3.68335H15.9024Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3456_16035">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
